import React from 'react'
import { Carousel } from 'antd-mobile';
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import DefaultBanner from '@assets/img/global/default-banner.png'
import BannerE from '@assets/img/global/banner-e.png'
import BannerD from '@assets/img/global/banner-d.png'
import BannerY from '@assets/img/global/banner-y.png'
import intl from '@utils/intl';
class CarouselG extends ComponentExt<any> {
    constructor(props) {
        super(props)
    }

    render() {
        const { list, operatorsId, active } = this.props
        const currentDate = new Date().getDate();
        const currentMonth = new Date().getMonth() + 1;
        return (
            <div>
                {
                    list.length > 0 ?
                        <Carousel autoplay infinite>
                            {
                                list.map((item, index) => (
                                    <img
                                        key={item.contentId}
                                        src={item.imagePath}
                                        className={styles.carouselImg}
                                        onLoad={() => window.dispatchEvent(new Event('resize'))}
                                    />
                                ))
                            }
                        </Carousel> :
                        active ? <img
                            src={DefaultBanner}
                            className={styles.carouselImg}
                            onLoad={() => window.dispatchEvent(new Event('resize'))}
                        /> : <img
                            // src={((operatorsId == 6) && ((currentMonth == 11 && currentDate >= 15) || currentMonth == 12 || (currentMonth == 1 && currentDate <= 15))) ? intl.formatMessage({ id: 'lang.chinese' }) == 'Chinese' ? BannerE : intl.formatMessage({ id: 'lang.chinese' }) == 'Chinesisch' ? BannerD : intl.formatMessage({ id: 'lang.chinese' }) == 'Cinese' ? BannerY : DefaultBanner : DefaultBanner}
                            src={DefaultBanner}
                            className={styles.carouselImg}
                            onLoad={() => window.dispatchEvent(new Event('resize'))}
                        />

                }
            </div>
        )
    }
}

export default CarouselG
